<template>
  <div>
    <div v-if="items && items.length > 0">
      <div
        v-for="(strategy, index) in items"
        :key="index"
        :class="[
          'flex',
          'flex-row',
          'list-item',
          'mb1',
          'has-position-relative',
        ]"
      >
        <!-- MODIFIED: Added $style.strategyItemContainer for relative positioning context -->
        <!-- MODIFIED: Wrapped content in a div for overlay positioning -->
        <div class="flex cell">
          <div class="flex cell flex-column">
            <b
              :class="[
                'shared-list-item-title',
                'is-ellipsis',
                'mbx',
                'mrx',
                $style.title,
              ]"
            >
              {{ strategy.title }}
            </b>
            <p
              v-if="strategy.gripDomainCategory"
              :class="['shared-list-item-category-box', 'mbx']"
            >
              {{ getUpperCase(strategy.gripDomainCategory.name) }}
            </p>
            <p :class="['is-ellipsis', 'mrx', $style.description]">
              {{ strategy.description }}
            </p>
          </div>
          <div>
            <a @click="handleEdit(strategy)" class="is-text-info prs">
              <b-icon icon="pencil" size="is-small" />
            </a>
            <!-- MODIFIED: Emit 'delete-strategy-request' instead of local handleDelete -->
            <a
              @click="$emit('delete-strategy-request', strategy.id)"
              class="is-text-info"
            >
              <b-icon icon="delete" size="is-small" />
            </a>
          </div>

          <!-- ADDED: Conditional overlay -->
          <div
            v-if="strategy.id === editingStrategyId && isMinimized"
            class="shared-list-item-edit-overlay"
            @click="$emit('restore-from-overlay')"
          >
            <span class="shared-list-item-overlay-text"
              >Resume Edit <i class="mdi mdi-arrow-expand"></i
            ></span>
          </div>
        </div>
      </div>
    </div>
    <div v-else :class="['flex', 'flex-row', 'list-item', 'mb1']">
      <div class="flex cell flex-column">
        <p class="text-size align-center text-color bold">No data found</p>
      </div>
    </div>
    <BasePagination
      v-if="items && items.length > 0"
      :class="$style.pagination"
      :page.sync="page"
      :perPage.sync="perPage"
      :totalNumberOfPage="totalNumberOfPage"
      :totalCount="totalCount"
      :isFirstPage="isFirstPage"
      :isLastPage="isLastPage"
      :startItemIndex="startItemIndex"
      :endItemIndex="endItemIndex"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Watch } from 'vue-property-decorator';
import { ToastProgrammatic as Toast } from 'buefy';
import { Action, State } from 'vuex-class';
import {
  GripStrategy,
  GripStrategyDTO,
  UpdateGripStrategyBase,
  UpdateGripStrategyPayload,
} from '../../../store/types/grip.types';
import { ApiState } from '../../../store/types/general.types';
import StrategyModal from './StrategyModal.vue';
import BasePagination from '../../../components/base/BasePagination.vue';
import DeleteModalBox from '../../../components/DeleteModalBox.vue';
import { isTruthy } from '../../../jbi-shared/util/watcher.vue-decorator';
import { PaginationMixin } from '../../../components/base/pagination.mixin';
import { mixins } from 'vue-class-component';
import { getUpperCase } from '../../../utils/general.util';

@Component({
  components: { BasePagination, StrategyModal, DeleteModalBox },
})
export default class StrategyList extends mixins(PaginationMixin) {
  @Prop() public items!: GripStrategy[];
  @Prop(Number) public totalNumberOfPage!: number;
  @Prop(Number) public totalCount!: number;
  @Prop(Boolean) public isFirstPage!: boolean;
  @Prop(Boolean) public isLastPage!: boolean;
  @Prop(Number) public startItemIndex!: number;
  @Prop(Number) public endItemIndex!: number;

  @Prop({ type: Number, default: null }) public editingStrategyId!:
    | number
    | null;
  @Prop({ type: Boolean, default: false }) public isMinimized!: boolean;

  get projectId(): number {
    return +this.$route.params.projectId;
  }

  public getUpperCase(value: string) {
    return getUpperCase(value);
  }

  public handleEdit(strategy: GripStrategy): void {
    this.$emit('edit-strategy', strategy);
  }
}
</script>
<style lang="scss" module>
.title {
  line-height: 1.0625rem; /* 17px */
  max-width: 70ch;
}

.description {
  max-width: 70ch;
}

.pagination nav {
  border-right: none !important;
}

.pagination nav ul {
  max-width: none !important;
}

.pagination nav li a,
.settingTabs nav li a:hover {
  height: auto !important;
  width: auto !important;
  font-size: 1rem !important;
  line-height: inherit !important;
  margin: 0.25rem !important;
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
  text-align: center !important;
  justify-content: center !important;
}
</style>
